import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-date-time-picker";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaseViewModel from "./../../factories/base-view-model";
import BaoDialog from "./../../factories/bao-dialog";
import baoRouter from "./../../services/bao-router";
export class FieldModel {
    FieldName = ko.observable("");
    FieldId = ko.observable(null);
    FieldValue = ko.observable("");
    constructor() {
        this.FieldId.subscribe(() => {
            if (this.FieldId() == null) {
                this.FieldValue(null);
            }
        });
    }
}
class DataExport extends BaseViewModel {
    TabPage: TabPage;
    ColumnProfileId = ko.observable("");
    GotoColumnProfileVisible = ko.observable(false);
    GotoColumnProfileVisibleHelper = ko.pureComputed(() => {
        return this.ColumnProfileId() != "" && this.GotoColumnProfileVisible();
    });
    ColumnProfileName = ko.observable("");
    GotoColumProfile = () => {
        if (this.ColumnProfileId() != "") {
            baoRouter.setHash('#columnprofile/' + this.ColumnProfileId());
        }
    };
    SearcherColumnProfile = {
        SearchType: "ColumnProfile",
        ObjectId: this.ColumnProfileId,
        ObjectValue: "Name",
        AutoComplete: true,
        AutoSearch: true,
        CustomFilter: { UsePermission: true },
        GotoVisible: this.GotoColumnProfileVisibleHelper,
        Goto: this.GotoColumProfile
    };
    // ----- Filter variables -----
    DataStateRadioButton = ko.observable("0");
    CreatedFrom = ko.observable("");
    CreatedTo = ko.observable("");
    CompletedFrom = ko.observable("");
    CompletedTo = ko.observable("");
    Username = ko.observable("");
    UserId = ko.observable("");
    OrgUnitId = ko.observable("");
    IncludeSubfolders = ko.observable(false);
    ChecklistId = ko.observable("");
    ListName = ko.observable("");
    RoleName = ko.observable("");
    RoleId = ko.observable("");
    InsertByUserFullName = ko.observable("");
    InsertByUserId = ko.observable("");
    FieldCollection = ko.observableArray([]);

    // ------ private fields for runtime-use --------
    defaultStartFromDate: any = null;
    defaultStartToDate: any = null;
    defaultCompleteFromDate: any = null;
    defaultCompleteToDate: any = null;

    //  ------ functions --------
    constructor(public tabPage: TabPage) {
        super(tabPage);
        this.TabPage = tabPage;
        let self = this;
        this.AddField();
        this.DataStateRadioButton.subscribe(function (value) {
            self.setDefaultDateData();

        })
    }
    //Button Bericht generieren:
    DownloadExcel() {
        if (!this.CompleteCheck()) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            return;
        }
        if (!this.CheckDates()) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFromLowerTo"), "info");
            return;
        }
        this.TabPage.IsLoading(true);
        let customFilter = this.GetCustomFilter();
        return Bao.post("DataExport/DownloadDataExportReport", JSON.stringify({
            completeBegin: this.CompletedFrom(),
            completeEnd: this.CompletedTo(),
            startBegin: this.CreatedFrom(),
            startEnd: this.CreatedTo(),
            columnProfileId: this.ColumnProfileId(),
            customFilter: customFilter,
            includeSubfolders: this.IncludeSubfolders(),
            dataStateRadioButton: this.DataStateRadioButton()
        }), (result) => {
            this.TabPage.IsLoading(false);
            if (result.IsCreated == true) {
                window.open(Bao.Content("BaoDocument/Download/" + result.Message), "_blank");
            }
            else if (result.IsCreated == false) {
                new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
            }
        });
    }
    ;

    setDefaultDateData() {
        if (this.DataStateRadioButton() == "0" || this.DataStateRadioButton() == "1") {
            if (this.defaultStartFromDate != null && this.DateIsNullOrEmpty(this.CreatedFrom())) {
                this.CreatedFrom(this.defaultStartFromDate);
            }
            if (this.defaultStartToDate != null && this.DateIsNullOrEmpty(this.CreatedTo())) {
                this.CreatedTo(this.defaultStartToDate);
            }
            if (this.DataStateRadioButton() == "1") {
                this.CompletedFrom("");
                this.CompletedTo("");
            }

        }
        if (this.DataStateRadioButton() == "2") {
            if (this.defaultCompleteFromDate != null && this.DateIsNullOrEmpty(this.CompletedFrom())) {
                this.CompletedFrom(this.defaultCompleteFromDate);
            }
            if (this.defaultCompleteToDate != null && this.DateIsNullOrEmpty(this.CompletedTo())) {
                this.CompletedTo(this.defaultCompleteToDate);
            }
            this.CreatedTo("");
            this.CreatedFrom("");
        }
    }

    //mit default Daten laden:
    init() {
        return Bao.post("DataExport/DataExportReportGetDefaultData", JSON.stringify({}),
            (result) => {
                if (result != null) {
                    this.defaultStartFromDate = result.StartFromDate;
                    this.defaultStartToDate = result.StartToDate;
                    this.defaultCompleteFromDate = result.CompleteFromDate;
                    this.defaultCompleteToDate = result.CompleteToDate;
                    this.setDefaultDateData();
                    this.GotoColumnProfileVisible(result.GotoVisible);
                    this.TabPage.Title(result.TabTitle);
                }
            }
        );
    }
    ;
    GetCustomFilter() {
        let customFilterHashObject = [];
        customFilterHashObject.push(this.AddHashObject("CreatedFrom", this.CreatedFrom()));
        customFilterHashObject.push(this.AddHashObject("CreatedTo", this.CreatedTo()));
        customFilterHashObject.push(this.AddHashObject("UserId", JSON.stringify(this.UserId())));
        customFilterHashObject.push(this.AddHashObject("OrgUnitId", this.OrgUnitId()));
        customFilterHashObject.push(this.AddHashObject("ChecklistId", this.ChecklistId()));
        customFilterHashObject.push(this.AddHashObject("Username", this.Username()));
        customFilterHashObject.push(this.AddHashObject("InsertByUserId", JSON.stringify(this.InsertByUserId())));
        customFilterHashObject.push(this.AddHashObject("RoleId", JSON.stringify(this.RoleId())));
        if (this.FieldCollection().length > 0) {
            this.FieldCollection().forEach((field) => {
                if (field.FieldId() != "" && field.FieldId() != null && field.FieldValue() != "" && field.FieldValue() != null) {
                    customFilterHashObject.push(this.AddHashObject("field", field.FieldId() + ";" + field.FieldValue()));
                }
            });
        }
        return customFilterHashObject;
    }
    AddHashObject(key: string, value: string) {
        let hashObject: any = {};
        hashObject.key = key;
        hashObject.value = value;
        return hashObject;
    }
    CompleteCheck() {
        let complete = true;
        if (this.ColumnProfileId() == null || this.ColumnProfileId() == "") {
            complete = false;
        }
        if ((this.DataStateRadioButton() == "0" || this.DataStateRadioButton() == "1") && this.DateIsNullOrEmpty(this.CreatedFrom())) {
            complete = false;
        }
        if ((this.DataStateRadioButton() == "0" || this.DataStateRadioButton() == "1") && this.DateIsNullOrEmpty(this.CreatedTo())) {
            complete = false;
        }
        if (this.DataStateRadioButton() == "2" && this.DateIsNullOrEmpty(this.CompletedFrom())) {
            complete = false;
        }
        if (this.DataStateRadioButton() == "2" && this.DateIsNullOrEmpty(this.CompletedTo())) {
            complete = false;
        }
        return complete;
    }
    DateIsNullOrEmpty(value) {
        if (value == null || value == "" || value == "Invalid date") {
            return true;
        }
        else {
            return false;
        }
    }

    CheckDates() {
        if (
            //this.Begin() > this.End() ||
            this.CreatedFrom() > this.CreatedTo() || this.CompletedFrom() > this.CompletedTo()) {
            return false;
        }
        return true;
    }
    AddField() {
        let newField = new FieldModel();
        this.FieldCollection.push(newField);
    }
    RemoveField() {
        if (this.FieldCollection().length > 0) {
            this.FieldCollection.pop();
        }
    }
}
export default DataExport;